import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import IconPackages from '@/assets/icons/heroIcons/Packages.svg';
import { DownloadButton } from '@/components/buttons';
import { OldDocumentsToggle } from '@/sections/documents/OldDocumentsToggle';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { Text } from '@/components/typography';
export function MaxiConditions(props) {
  const $ = _c(77);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["termsAndConditions"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.4.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconPackages className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("categories.4.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("categories.4.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("categories.4.list.1");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <li>{t7}</li>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("categories.4.list.2");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <li>{t9}</li>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("categories.4.list.3");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li>{t11}</li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("categories.4.list.4");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <li>{t13}</li>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t14 || $[31] !== t8) {
    t15 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500 lg:mb-12">{t8}{t10}{t12}{t14}</ul>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t8;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== locale) {
    t16 = FILES(locale);
    $[33] = locale;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = <Trans t={t} i18nKey="categories.4.documents.oldConditions">{"15. 10. 2026"}</Trans>;
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t16.termsAndConditionsMaxiUntil15102026 || $[38] !== t17) {
    t18 = <div className="mb-2 lg:mb-4"><DownloadButton to={t16.termsAndConditionsMaxiUntil15102026} testId="termsAndConditionsMaxiValidUntil" analyticsParam="termsAndConditionsMaxiValidUntil" className="sm:w-full">{t17}</DownloadButton></div>;
    $[37] = t16.termsAndConditionsMaxiUntil15102026;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== locale) {
    t19 = FILES(locale);
    $[40] = locale;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = <Trans t={t} i18nKey="categories.4.documents.upcoming">{"16. 10. 2026"}</Trans>;
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t19.termsAndConditionsMaxi || $[45] !== t20) {
    t21 = <div className="mb-2 lg:mb-4"><DownloadButton to={t19.termsAndConditionsMaxi} testId="termsAndConditionsMaxi" analyticsParam="termsAndConditionsMaxi" className="sm:w-full">{t20}</DownloadButton></div>;
    $[44] = t19.termsAndConditionsMaxi;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== locale) {
    t22 = FILES(locale);
    $[47] = locale;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const t23 = t22.termsAndConditionsMaxiSamplePreContractualInformation;
  let t24;
  if ($[49] !== t) {
    t24 = t("categories.4.documents.preContractualInformation");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t22.termsAndConditionsMaxiSamplePreContractualInformation || $[52] !== t24) {
    t25 = <div className="mb-2 lg:mb-4"><DownloadButton to={t23} testId="preContractualInformationMaxi" analyticsParam="preContractualInformationMaxi" className="sm:w-full">{t24}</DownloadButton></div>;
    $[51] = t22.termsAndConditionsMaxiSamplePreContractualInformation;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== locale) {
    t26 = FILES(locale);
    $[54] = locale;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  const t27 = t26.termsAndConditionsMaxiSampleContract;
  let t28;
  if ($[56] !== t) {
    t28 = t("categories.4.documents.contract");
    $[56] = t;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t26.termsAndConditionsMaxiSampleContract || $[59] !== t28) {
    t29 = <DownloadButton to={t27} testId="contractMaxi" analyticsParam="contractMaxi" className="sm:w-full">{t28}</DownloadButton>;
    $[58] = t26.termsAndConditionsMaxiSampleContract;
    $[59] = t28;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t18 || $[62] !== t21 || $[63] !== t25 || $[64] !== t29) {
    t30 = <div className="inline-block">{t18}{t21}{t25}{t29}</div>;
    $[61] = t18;
    $[62] = t21;
    $[63] = t25;
    $[64] = t29;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== locale || $[67] !== t) {
    t31 = !!FILES(locale).oldTermsAndConditionsMaxi.length && <div className="mt-4"><OldDocumentsToggle closedTitle={t("show")} openedTitle={t("hide")}>{FILES(locale).oldTermsAndConditionsMaxi.map(t32 => {
          const {
            path,
            date,
            customLabel
          } = t32;
          return <div className="mb-2 lg:mb-4" key={path}><DownloadButton to={path} testId="termsAndConditionsCardOld" analyticsParam="termsAndConditionsCardOld" variant="old" className="sm:w-full">{customLabel ? <Text as="p" variant="p3">{customLabel}</Text> : <Trans t={t} i18nKey="categories.4.documents.oldConditions">{date}</Trans>}</DownloadButton></div>;
        })}{FILES(locale).oldCardTermsAndConditions.map(t33 => {
          const {
            path: path_0,
            date: date_0
          } = t33;
          return <div className="mb-2 lg:mb-4" key={path_0}><DownloadButton to={path_0} testId="termsAndConditionscardOld" analyticsParam="termsAndConditionscardOld" variant="old" className="sm:w-full"><Trans t={t} i18nKey="categories.4.documents.oldCardsConditions">{date_0}</Trans></DownloadButton></div>;
        })}</OldDocumentsToggle></div>;
    $[66] = locale;
    $[67] = t;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== props || $[70] !== t1 || $[71] !== t15 || $[72] !== t30 || $[73] !== t31 || $[74] !== t4 || $[75] !== t6) {
    t32 = <DocumentSection title={t1} icon={t2} {...props}>{t4}{t6}{t15}{t30}{t31}</DocumentSection>;
    $[69] = props;
    $[70] = t1;
    $[71] = t15;
    $[72] = t30;
    $[73] = t31;
    $[74] = t4;
    $[75] = t6;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  return t32;
}